/**
 * Derives a stable, user-unique session identifier from a Supabase JWT.
 * Uses SHA-256 over the full token — the old btoa(token).slice(0, 64) approach
 * collided across users because all project JWTs share the same header prefix.
 */
export async function hashSessionToken(token: string): Promise<string> {
  const data = new TextEncoder().encode(token);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
